import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-category-carousel',
  templateUrl: './category-carousel.component.html',
  styleUrls: ['./category-carousel.component.scss']
})
export class CategoryCarouselComponent implements OnInit {
  @Input() imageSrc = [{
    src: 'assets/Carousel-1.png',
    text: 'Make Up'
  },
  {
    src: 'assets/carousel-2.png',
    text: 'Women Wear'
  },
  {
    src: 'assets/carousel-3.png',
    text: 'Jewellery'
  },
  {
    src: 'assets/carousel-4.png',
    text: 'Accessorries'
  },
  {
    src: 'assets/carousel-5.png',
    text: 'Footwear'
  },
  {
    src: 'assets/carosel-6.png',
    text: 'Handbag'
  }]


  constructor() { }

  ngOnInit(): void {
  }

}
